module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(compare, function(player){ 
__p+='\n	<div class="stat-box">\n		<div class="stat-box-header">\n			<div class="col col-1">RND</div>\n			<div class="col col-2">OPPONENT</div>\n			<div class="col col-3">PRICE</div>\n			<div class="col col-4">POINTS</div>\n		</div>\n		<ul class="stat-box-body">\n			';
 _.each(rounds_range, function(round){ 
__p+='\n				<li class="'+
((__t=( round.is_coach && has_assistant_coach ? 'is-coach-data' : '' ))==null?'':_.escape(__t))+
'">\n					<div class="col col-1">'+
((__t=( round.id ))==null?'':_.escape(__t))+
'</div>\n					<div class="col col-2">\n						';
 if(player.stats_table[round.id].opponent.id){ 
__p+='\n							<img class="squad-logo" src="'+
((__t=( SQUADS_PATH + player.stats_table[round.id].opponent.id ))==null?'':_.escape(__t))+
'.png" alt="">\n						';
 } 
__p+='\n						<span>('+
((__t=( player.stats_table[round.id].opponent.side ))==null?'':_.escape(__t))+
')</span>\n					</div>\n					<div class="col col-3">\n						';
 if(!(_.eq(player.stats_table[round.id].price.change, 'none') && round.is_coach && !has_assistant_coach)){ 
__p+='\n							<i class="price-change-dir '+
((__t=( player.stats_table[round.id].price.change ))==null?'':_.escape(__t))+
'"></i>\n						';
 } 
__p+='\n						<span>'+
((__t=( player.stats_table[round.id].price.value ))==null?'':_.escape(__t))+
'</span>\n					</div>\n					<div class="col col-4">\n						';
 if(round.is_coach && _.isNumber(player.stats_table[round.id].points)){ 
__p+='\n							<span>'+
((__t=( player.stats_table[round.id].points ))==null?'':_.escape(__t))+
'</span>\n						';
 } else { print(player.stats_table[round.id].points) } 
__p+='\n					</div>\n				</li>\n			';
 }) 
__p+='\n		</ul>\n		<a href="/player-profile/'+
((__t=( player.id ))==null?'':_.escape(__t))+
'" target="_blank" class="btn">FULL PROFILE</a>\n	</div>\n';
 }) 
__p+='';
}
return __p;
};
